import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuicklinkStrategy } from 'ngx-quicklink';

import { titles } from 'app/constants';
import { MasterLayoutComponent } from 'app/layouts';
import { AuthGuard, AccessGuard } from 'app/services';
import { P404Component, LoginComponent, ForgotPasswordComponent, ApptVerifyComponent, ResetPasswordComponent, ReleaseNotesComponent, NavigateCompanyViewComponent } from 'app/modules/app-components';
import { SetPrefrencesComponent } from './modules/app-components/create-prefrences/set-prefrences/set-prefrences.component';
import { SavePrefrencesComponent } from './modules/app-components/create-prefrences-save/save-prefrences/save-prefrences.component';
import { WarrantyPolicyTermsComponent } from 'app/modules/app-components';
import { HealthFrontEndComponent } from './modules/app-components/health-frontend/health-frontend.component';
import { RedirectComponent } from './redirect/redirect.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'self-onboarding/:appt_conf_token',
    loadChildren: () => import('./modules/self-onboarding/self-onboarding.module').then((m) => m.SelfOnboardingModule),
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { id: 'login' },
  },
  {
    path: 'appt-verify/:appt_conf_token',
    component: ApptVerifyComponent,
    data: { id: 'appt-verify' },
  },
  {
    path: 'warranty-policy-terms/:id/:appt_conf_token',
    component: WarrantyPolicyTermsComponent,
    data: {
      id: 'warranty-policy-terms',
    },
  },
  {
    path: 'warranty-policy-terms/:id',
    component: WarrantyPolicyTermsComponent,
    data: {
      title: 'Warranty Policy',
      id: 'warranty-policy-terms',
    },
  },
  {
    path: 'set-prefrences/:appt_conf_token',
    component: SetPrefrencesComponent,
    // data: { id: 'appt-verify' },
  },
  {
    path: 'save-prefrences/:appt_conf_token',
    component: SavePrefrencesComponent,
    // data: { id: 'appt-verify' },
  },
  {
    path: 'unsubscribe/contact/:appt_conf_token',
    component: SetPrefrencesComponent,
    data: { id: 'unsubscribe-link' },
  },
  {
    path: 'routed-company-view/:token/:sso',
    component: NavigateCompanyViewComponent,
    data: { id: 'routed-company-view' },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: { id: 'forgot-password' },
  },
  {
    path: 'health-frontend',
    component: HealthFrontEndComponent,
    data: { id: 'health-frontend' },
  },
  {
    path: 'set-password/:token',
    component: ResetPasswordComponent,
    data: { id: 'set-password' },
  },
  {
    path: '404',
    component: P404Component,
    data: { id: 'page-404' },
  },
  {
    path: 'redirect',
    component: RedirectComponent,
    data: { id: 'redirect' },
  },
  {
    path: 'customer-review',
    loadChildren: () => import('./modules/customer/customer.module').then((m) => m.CustomerModule),
  },
  {
    path: 'print-view',
    loadChildren: () => import('./modules/print-view/print-view.module').then((m) => m.PrintViewModule),
  },
  {
    path: 'customer-appointment-request',
    loadChildren: () => import('./modules/customer-appointment-request/customer-appointment-request.module').then((m) => m.CustomerAppointmentRequestModule),
  },
  {
    path: 'customer-feedback',
    loadChildren: () => import('./modules/customer-feedback/customer-feedback.module').then((m) => m.CustomerFeedbackModule),
  },
  {
    path: 'release-notes',
    canActivate: [AuthGuard],
    canActivateChild: [AccessGuard],
    component: ReleaseNotesComponent,
    data: { title: titles.releaseNotes },
  },
  {
    path: '',
    component: MasterLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AccessGuard],
    data: { id: 'master' },
    children: [
      {
        path: 'dashboard',
        data: { title: titles.dashboard },
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'workboard',
        data: { title: titles.workboard },
        loadChildren: () => import('./modules/workboard/workboard.module').then((m) => m.WorkboardModule),
      },
      {
        path: 'calendar',
        data: { title: titles.calendar },
        loadChildren: () => import('./modules/calender/calender.module').then((m) => m.CalenderModule),
      },
      {
        path: 'estimate',
        loadChildren: () => import('./modules/estimate/estimate.module').then((m) => m.EstimateModule),
      },
      {
        path: 'customers',
        loadChildren: () => import('./modules/customers/customers.module').then((m) => m.CustomersModule),
      },
      {
        path: 'customer',
        loadChildren: () => import('./modules/customer-center/customer-center.module').then((m) => m.CustomerCenterModule),
      },
      {
        path: 'catalog',
        loadChildren: () => import('./modules/catalog/catalog.module').then((m) => m.CatalogModule),
      },
      {
        path: 'marketing/follow-up',
        loadChildren: () => import('./modules/follow-up-campaign/follow-up-campaign.module').then((m) => m.FollowUpCampaignModule),
      },
      {
        path: 'marketing',
        loadChildren: () => import('./modules/marketing/marketing.module').then((m) => m.MarketingModule),
      },
      {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory.module').then((m) => m.InventoryModule),
      },
      {
        path: 'purchase-order',
        data: { id: 'purchase-order' },
        loadChildren: () => import('./modules/inventory/components/purchase-order/purchase-order.module').then((m) => m.PurchaseOrderModule),
      },
      {
        path: 'transfer-stock',
        data: { id: 'transfer-stock' },
        loadChildren: () => import('./modules/inventory/components/transfer-stock/transfer-stock.module').then((m) => m.TransferStockModule),
      },
      {
        path: 'purchase-online-order',
        data: { id: 'purchase-online-order' },
        loadChildren: () => import('./modules/inventory/components/purchase-online-order/purchase-online-order.module').then((m) => m.PurchaseOnlineOrderModule),
      },
      {
        path: 'reviews',
        loadChildren: () => import('./modules/reviews/reviews.module').then((m) => m.ReviewsModule),
      },
      {
        path: 'reports',
        data: { title: 'Reports' },
        loadChildren: () => import('./modules/reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'company',
        loadChildren: () => import('./modules/company/company.module').then((m) => m.CompanyModule),
      },
      {
        path: 'settings',
        data: { title: 'Settings' },
        loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'chat',
        data: { title: 'Chats', id: 'main-chats' },
        loadChildren: () => import('./modules/chat/chats.module').then((m) => m.ChatsModule),
      },
      {
        path: 'new-company',
        loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'activity-logs',
        data: { title: 'Activity Logs' },
        loadChildren: () => import('./modules/activity-logs/activity-logs.module').then((m) => m.ActivityLogsModule),
      },
      {
        path: 'qbo-bulk-post',
        data: { title: 'Bulk Posting' },
        loadChildren: () => import('./modules/qbo-bulkpost-report/qbo-bulkpost-report.module').then((m) => m.QboBulkpostReportModule),
      },
      {
        path: 'user-center',
        loadChildren: () => import('./modules/user-center/user-center.module').then((m) => m.UserCenterModule),
      },
    ],
  },
  {
    path: 'tech',
    data: { id: 'tech' },
    loadChildren: () => import('./modules/technician/technician.module').then((m) => m.TechnicianModule),
    canActivate: [AuthGuard],
    canActivateChild: [AccessGuard],
  },
  { path: '**', component: P404Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: QuicklinkStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
